<template>
    <el-dialog
        title="用户协议"
        :visible.sync="visible"
        width="600px"
        :close-on-click-modal="false"
        @close="handleClose"
    >
        <!-- 第一步：提示签署 -->
        <div v-if="currentStep === 1" class="step-content">
            <div class="agreement-notice">
                <i class="el-icon-warning" style="color: #E6A23C; font-size: 48px; margin-bottom: 20px;"></i>
                <h3 v-if="agreementStatus === 1">您还没有签署用户协议</h3>
                <h3 v-if="agreementStatus === 3">审核不通过，需要重新签署用户协议</h3>
                <p v-if="agreementStatus === 1">为了确保您能正常使用系统的所有功能，请先签署用户协议。</p>
                <p v-if="agreementStatus === 3">您之前提交的协议材料审核未通过，请重新提交相关资料。</p>
                <p style="color: #909399; font-size: 14px;">这是为了保护您的权益和明确双方的责任。</p>
            </div>
        </div>

        <!-- 第二步：阅读协议 -->
        <div v-if="currentStep === 2" class="step-content">
            <div class="agreement-content">
                <h4>用户协议</h4>
                <div class="agreement-text">
                    <h2>系统注册及物流服务合作协议</h2>
                    <p><strong>承运方（以下简称甲方）：</strong>深圳圣捷国际物流有限公司</p>
                    <p><strong>委托方（以下简称乙方）：</strong><strong><u>以乙方提供的顺运宝系统注册信息为准</u></strong></p>
                    <p>根据《中华人民共和国合同法》及有关法律规定，甲、乙双方在协商一致的基础上，本着自愿、公平和诚信的原则，双方就甲方为乙方提供货运代理服务事宜达成如下协议，双方共同遵守、执行：</p>
                    
                    <p><strong>第一条：费用计价</strong></p>
                    <p>1．本合同期限自乙方注册甲方"顺运宝"系统之日起计算，为期一年，合同期满后，双方如无意终止，本协议自动延续1年，以次类推；本协议解除时，双方发生或未完成的业务或事宜，双方应继续履行至有关业务或事宜完成止。</p>
                    <p>2．乙方委托甲方为其货运服务代理人，代办乙方发至目的地国/地区货物运输服务事宜。运价按照市场航空成本报价之定价！</p>
                    <p>3．甲方为乙方提供仓储服务、运输服务、派送服务、代收货款服务。</p>
                    <p>4．物流专线服务类别：台湾线、香港线、泰国线、越南线、印度尼西亚线、日本线等其他物流专线。</p>
                    
                    <p><strong>第二条：双方权力及义务</strong></p>
                    <p>1．乙方负责提供货物，由甲方安排货运物流服务，甲方在收到货物后应确保将货物运送到客户指定地址，乙方有权利知晓包裹物流轨迹服务信息。</p>
                    <p>2．乙方出运的货物，不得夹带易燃、易爆物品及国家/地区规定禁止进口之物，如果一旦发现乙方运输的货物不符合运输规定，则甲方有权不予运输，且视为乙方违约，造成所发的货物给甲方带来任何经济损失和法律责任将由乙方承担一切连带责任。</p>
                    <p>3．乙方应准确、完整的填写货物运输所需要的文件，若因乙方所提供的货物资料与实际货物不符而导致的损失和责任有乙方承担。</p>
                    <p>4．甲方按照乙方提供的资料收、发包裹，在约定时间和地点接收乙方委托派送的包裹，甲方提货人须当面签署乙方仓库管理人员开具的相关出货产品信息清单，并核对交货数量，清单随货交运给到甲方相关操作负责人，甲方有权查验乙方交来的包裹货件，有权抽查内部。甲方提货人员须配合乙方现场管理人员安排，到指定停放位置进行收货。</p>
                    <p>5．乙方应保证包裹信息真实、完整和准确，并承诺包裹内不能含有违反目的地国/地区法律法规的物品。</p>
                    <p>6．甲方派送上门时，若收件人拒收货件或拒付货款，乙方都须向甲方支付物流费用。若乙方将货件更改地址派送，乙方须向甲方支付二次派送费。</p>
                    
                    <p><strong>第三条：费用及结算时间</strong></p>
                    <p>1．乙方交甲方派送的货件属商业项目，双方同意按照《商业项目报价表》内收费价格结算，每个订单的单价核算物流相关所有费用（从到乙方收取货到派送到客人手中所有物流相关费用），合同期内单价不变。如需要调整变更，须经甲、乙双方协商一致后方可执行。</p>
                    <p>2．费用账单时间为每周一次，双方按照订单对应的有效运单号进行核算。</p>
                    <p><strong><u>若乙方对甲方发出的账单金额存在异议，乙方应在三个工作日内与甲方财务协商核对，双方应在两个工作日内进行最终确认，逾期将视为乙方已经自动确认该账单。</u></strong></p>
                    <p>1)甲，乙双方保有对于应收费用的增补权，保有对多付费用的追索权，对于须使用增补权或追索权的费用，双方应在下一个账单周期内结算。</p>
                    <p>2)乙方如出现到期未对账或未结算，且连续30天以上未委托甲方承运货物的情况，视为乙方违约，本协议自动终止。经甲方催告后3个工作日仍未对账和结算的，甲方有权追究违约责任。</p>
                    <p>3)账单确认金额的款项只能退至收款方指定的账户，收款账户以甲、乙方提供的财务切结书为准，甲、乙双方如果变更账户资料，须提前10个工作日书面通知对方。因未提前通知对方而造成损失的，无须为对方负任何责任。</p>
                    
                    <p><strong>第四条：保密责任</strong></p>
                    <p>1．本合同内容应被严格保密，不得以任何形式向任何商家透露。</p>
                    <p>2．任何一方不应使用或允许他人使用在其同对方发生往来时所获得的任何信息，甲方须遵守对乙方产品的保密性，不得向第三方泄露乙方产品资料及出货信息。</p>
                    
                    <p><strong>第五条：违约责任</strong></p>
                    <p>1．自合同生效后，甲、乙双方应严格履行本合同，若任何一方不履行或不按约定履行均构成违约的，守约方有权利单方面终止合同，违约方应赔偿由此给守约方造成的全部合理损失。</p>
                    <p>2．合同生效后，若甲、乙双方需要提前解除本合同，须提前30天向对方发出书面解约通知，经双方协商达成一致后，可以解除本合约。</p>
                    <p>3．由于罢工、战争、自然灾害、航班延误、海关查验、政府行为、疫情、快递服务商内部操作等不可抗力造成的任何损失和延误，甲方不承担任何责任。</p>
                    
                    <p><strong>第六条：争议解决</strong></p>
                    <p>1．本协议受国家法律约束，不得有违背法律的条款，与本协议有关的一切争议，协议各方应通过友好协商的方式解决，如协商不成，任何一方均可甲方所在地的人民法院提起诉讼，违约的一方需承担守约方因追索违约责任所导致的全部经济损失，包括但不限于合理的律师费、诉讼费、保全费及调查取证支出的有关费用。</p>
                    
                    <p><strong>第七条：合同生效及其他</strong></p>
                    <p>1．本合同乙方勾选系统"已阅读，同意"后，自动备份到甲方生效合同数据库，视为甲乙双方同意本协议中所有条款，即合同生效。</p>
                    <p>2．本合同未尽事项，可由双方另外签订补充协议，补充协议或补充条款经双方签署盖章后，为本协议的组成部分，与本协议具有同等效力。</p>
                    <p><strong><u>3．附件（双方营业执照，乙方如为个人主体，则提供身份证正反面），双方保证对以上主体信息的真实性承担责任，如出现提供虚假信息的情况，提供人对债务承担连带责任，并自愿根据不同情节承担包括但不限于合同诈骗罪等刑事责任。</u></strong></p>
                    
                    <p><strong>补充条款：甲方代理人头申报的，存在一定扣货风险，如产生高额税金或需要补充提交资料，一切责任由乙方自行承担，与甲方无关；如遇需要提供甲方名字进行申报的情况，若乙方在APP上操作不当点击申报不相符，导致冒名，会产生罚款，该费用由乙方自行承担。</strong></p>
                </div>
                
                <div class="agreement-checkbox">
                    <el-checkbox v-model="agreementChecked">我已阅读并同意《用户协议》</el-checkbox>
                </div>
            </div>
        </div>

        <!-- 第三步：上传身份证 -->
        <div v-if="currentStep === 3" class="step-content">
            <div class="upload-content">
                <h4>请上传身份证照片</h4>
                <p style="color: #909399; margin-bottom: 20px;">为了完成实名认证，请上传清晰的身份证正反面照片</p>
                
                <div class="upload-section">
                    <div class="upload-item">
                        <label>身份证正面：</label>
                        <el-upload
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :show-file-list="false"
                            :on-success="handleFrontSuccess"
                            :before-upload="beforeUpload"
                            :file-list="frontFileList"
                            :with-credentials="true"
                            accept="image/*"
                        >
                            <img v-if="idCardFront" :src="getImageUrl(idCardFront)" alt="身份证反面" class="avatar" @click="previewImage(getImageUrl(idCardFront))">
                            <i v-else class="el-icon-plus avatar-uploader-icon" style="position:relative; top: 80px;"></i>
                        </el-upload>
                    </div>
                    
                    <div class="upload-item">
                        <label>身份证反面：</label>
                        <el-upload
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :show-file-list="false"
                            :on-success="handleBackSuccess"
                            :before-upload="beforeUpload"
                            :file-list="backFileList"
                            :with-credentials="true"
                            accept="image/*"
                        >
                            <img v-if="idCardBack" :src="getImageUrl(idCardBack)" alt="身份证反面" class="avatar" @click="previewImage(getImageUrl(idCardBack))">
                            <i v-else class="el-icon-plus avatar-uploader-icon" style="position:relative; top: 80px;"></i>
                        </el-upload>
                        
                       
                    </div>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button v-if="currentStep === 1" type="primary" @click="nextStep">同意</el-button>
            <el-button v-if="currentStep === 2" @click="prevStep">上一步</el-button>
            <el-button v-if="currentStep === 2" type="primary" @click="submitAgreement" :disabled="!agreementChecked">
                同意 {{ agreementChecked ? '(已勾选)' : '(未勾选)' }}
            </el-button>
            <!-- 暂时不需要提交身份证
            <el-button v-if="currentStep === 3" @click="prevStep">上一步</el-button>
            <el-button v-if="currentStep === 3" type="primary" @click="submitAgreement" :disabled="!canSubmit" :loading="submitting">确认提交</el-button>
            -->
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "Agreement",
    data() {
        return {
            visible: false,
            currentStep: 1,
            agreementChecked: false,
            idCardFront: null,
            idCardBack: null,
            submitting: false,
            frontFileList: [],
            backFileList: [],
            agreementStatus: 1
        }
    },
    computed: {
        uploadUrl() {
            return this.$kit.api.upload + "?type=agreement&auth=1";
        },
        canSubmit() {
            return this.idCardFront && this.idCardBack;
        }
    },
    methods: {
        show(userProfile) {
            this.visible = true;
            this.currentStep = 1;
            this.agreementChecked = false;
            this.idCardFront = null;
            this.idCardBack = null;
            this.submitting = false;
            this.frontFileList = [];
            this.backFileList = [];
            
            if (userProfile) {
                this.agreementStatus = userProfile.agreementStatus || 1;
                this.idCardFront = userProfile.idCardFront || null;
                this.idCardBack = userProfile.idCardBack || null;
            } else {
                this.agreementStatus = 1;
                this.idCardFront = null;
                this.idCardBack = null;
            }
        },
        
        handleClose() {
            this.visible = false;
            this.$emit('close');
        },
        
        nextStep() {
            // 在第2步时检查是否已勾选协议
            if (this.currentStep === 2 && !this.agreementChecked) {
                this.$message.error('请先勾选同意协议');
                return;
            }
            
            if (this.currentStep < 3) {
                this.currentStep++;
            }
        },
        
        prevStep() {
            if (this.currentStep > 1) {
                this.currentStep--;
            }
        },
        
        beforeUpload(file) {
            const isImage = file.type.indexOf('image/') !== -1;
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                this.$message.error('只能上传图片文件!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            return true;
        },
        
        handleFrontSuccess(response) {
            if (response.status) {
                this.idCardFront = response.data;
                this.$message.success('身份证正面上传成功');
            } else {
                this.$message.error(response.msg || '上传失败');
            }
        },
        
        handleBackSuccess(response) {
            if (response.status) {
                this.idCardBack = response.data;
                this.$message.success('身份证反面上传成功');
            } else {
                this.$message.error(response.msg || '上传失败');
            }
        },
        
        submitAgreement() {
            /*
            if (!this.canSubmit) {
                this.$message.error('请先上传身份证正反面照片');
                return;
            }
            
            this.submitting = true;
            
            const requestData = {
                idCardFront: this.idCardFront,
                idCardBack: this.idCardBack
            };
            
            this.$axios.post(this.$kit.api.user.agreeUserAgreement, requestData)
                .then((result) => {
                    this.submitting = false;
                    this.$message.success(result.msg);
                    if (result.status) {
                        this.visible = false;
                        this.$emit('success');
                    }
                })
                .catch((error) => {
                    this.submitting = false;
                    console.error('提交失败:', error);
                    this.$message.error('提交失败，请重试');
                });
                
                */

            if (!this.agreementChecked) {
                this.$message.error('请先勾选同意协议');
                return;
            }
            this.$axios.get(this.$kit.api.user.agreeUserAgreement)
                .then((result) => {
                    this.submitting = false;
                    this.$message.success(result.msg);
                    if (result.status) {
                        this.visible = false;
                        this.$emit('success');
                    }
                })
                .catch((error) => {
                    this.submitting = false;
                    console.error('提交失败:', error);
                    this.$message.error('提交失败，请重试');
                });   
        },
        
        getImageUrl(id) {
            return this.$kit.api.imgView + id;
        },
        
        previewImage(url) {
            // Implement image preview logic here
            console.log('Preview image:', url);
        }
    }
}
</script>

<style>
.step-content {
    min-height: 300px;
    padding: 20px 0;
}

.agreement-notice {
    text-align: center;
    padding: 40px 20px;
}

.agreement-notice h3 {  
    color: #303133;
    margin: 20px 0 15px 0;
    font-size: 18px;
}

.agreement-notice p {
    color: #606266;
    line-height: 1.6; 
    margin: 10px 0;   
}

.agreement-content h4 {
    color: #303133;
    margin-bottom: 20px;
    text-align: center;
    font-size: 16px;
}

.agreement-text {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 15px;
    background-color: #FAFAFA;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 20px;
}

.agreement-text p {
    margin: 8px 0;
    color: #606266;
}

.agreement-text strong {
    color: #303133;
}

.agreement-checkbox {
    text-align: center;
}

.upload-content h4 {
    color: #303133;
    margin-bottom: 10px;
    font-size: 16px;
}

.upload-section {
    margin-top: 20px;
}

.upload-item {
    margin-bottom: 25px;
    display: flex;
    align-items: flex-start;
    gap: 15px;
}

.upload-item label {
    min-width: 100px;
    font-weight: 500;
    color: #303133;
    line-height: 32px;
}

.upload-success {
    margin-top: 8px;
    color: #67C23A;
    font-size: 14px;
}

.existing-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}

.existing-image img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
    margin-bottom: 8px;
}

.existing-image p {
    color: #606266;
    font-size: 14px;
}

.dialog-footer {
    text-align: center;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 320px;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
  .avatar {
    width: 320px;
    height: 200px;
    display: block;
  }
</style> 